import { render } from "./MDBSideNavMenu.vue?vue&type=template&id=b5a6e462"
import script from "./MDBSideNavMenu.vue?vue&type=script&lang=js"
export * from "./MDBSideNavMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/foo/Work/Aquent/Plex/plex-interactive/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.33_vue@3.2.33_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__